import React, { useEffect, useState } from 'react'
import { FormBox, InputBox } from '../../../../components/AntdAddons'
import { Button,  Col, Divider, Form, Row } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../store/app'
import { rules } from './Rules'
import { useNavigate } from 'react-router-dom'
import { doLogin, setSessionTimeOut,  } from '../../../../store/AuthSlice'
import { assignErrorToInput } from '../../../../store/api'
import loginbgMob from "../../../../assets/images/login-img-new-mobile.svg"
import { WebConstant } from '../../webConstant/WebConstant'
/**
 * Renders the Login component contains login form.
 *
 * @return {JSX.Element} The rendered WebLogin component.
 */
const WebLoginThink = () => {
    const [form] = Form.useForm();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate()
    const bannerContent = useSelector((state: RootState) => state.HOME?.pageSettings)
    console.log(bannerContent)
    // Submit Login Form and navigate to dashboard
    const handleSubmit = (data: any) => {
        const req = {
            email: data.email,
        };
        dispatch(doLogin(req, 'thinkific'))
            .then(() => {
                navigate("/dashboard");
                dispatch(setSessionTimeOut(true))
            })
            .catch((error: any) => assignErrorToInput(form, error?.STATUS))
    }

    
   

    const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)



    return (
        <>
            <section className={`webLoginSection`}>

                <Row className='no-gutter'>
                    <Col xxl={12} xl={12} lg={12} md={24} sm={24}>
                        <div className="login-bg">
                            <div className="login-bg-in"><img src={loginbgMob} alt="" /></div>
                        </div>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={24} className='form-col'>
                        <div className='webLoginBox'>
                            <div className="login-logo">
                                <Link to={'/login'}>
                                    <img src={WebConstant?.IMAGE_URL + logo} alt="" />
                                </Link>
                            </div>
                            <h2 className="subtitle">Welcome</h2>
                            <p>Log in to continue your energy journey.</p>
                            <FormBox form={form} onFinish={handleSubmit}>
                                <InputBox.Text
                                    name="email"
                                    label={<>Email <em>*</em></>}
                                    placeholder=''
                                    className='ecn-input'

                                    rules={rules.username()}
                                />
                                <div className='forgetPass'>
                                    <div className='logInBtn'>
                                        <Button className='log_in_button secondry_btn_log_page green-btn' htmlType='submit'>
                                            Continue
                                        </Button>
                                    </div>
                                </div>
                            </FormBox>
                        </div>
                    </Col>
                </Row>


            </section>
        </>
    )
}



export default WebLoginThink